export function getPageSize(): number {
  return 12;
}
